import {
  REQUEST_PUSH_MESSAGES, RECEIVE_PUSH_MESSAGES, REQUEST_PUSH_MESSAGE, RECEIVE_PUSH_MESSAGE,
  REQUEST_PUSH_DEVICES, RECEIVE_PUSH_DEVICES, REQUEST_PUSH_DEVICE_ACTION, RECEIVE_PUSH_DEVICE_ACTION,
} from '../constants/ActionTypes'

const INITIAL_LIST = {
  rows: [],
  count: 0,
  page: 1,
  limit: 50,
}

const INITIAL_STATE = {
  messages: {
    isLoading: false,
    data: INITIAL_LIST,
    receivedAt: null,
  },
  message: {
    data: {},
    isLoading: false,
  },
  devices: {
    isLoading: false,
    data: INITIAL_LIST,
    receivedAt: null,
  },
  deviceAction: {
    isLoading: false,
  },
}

export default function PushReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_PUSH_MESSAGES:
      return {
        ...state,
        messages: {
          ...state.messages,
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_PUSH_MESSAGES:
      return {
        ...state,
        messages: {
          isLoading: action.isLoading,
          data: action.data || INITIAL_LIST,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_PUSH_MESSAGE:
      return {
        ...state,
        message: {
          data: {},
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_PUSH_MESSAGE:
      return {
        ...state,
        message: {
          data: action.data || {},
          isLoading: action.isLoading,
        }
      }
    case REQUEST_PUSH_DEVICES:
      return {
        ...state,
        devices: {
          ...state.devices,
          isLoading: action.isLoading,
        }
      }
    case RECEIVE_PUSH_DEVICES:
      return {
        ...state,
        devices: {
          isLoading: action.isLoading,
          data: action.data || INITIAL_LIST,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_PUSH_DEVICE_ACTION:
    case RECEIVE_PUSH_DEVICE_ACTION:
      return {
        ...state,
        deviceAction: {
          isLoading: action.isLoading,
        }
      }
    default:
      return state
  }
}
